// @ts-nocheck
var gsap;

const scrollingPage = () => {
    textAnimations()
}

const textAnimations = () => {
    const sectionReveals = document.querySelectorAll('.secReveals')
    let pathN = window.location.pathname
    let pathNMo = pathN.slice(1)
    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let titles = entry.target
                let titlesAn = titles?.querySelectorAll('.headline')
                titlesAn.forEach((tl) => {
                    tl?.classList.add("set")
                })
                entry.target.classList.add("reveal")
            }
        })
    }
    const options = {
        root: null,
        rootMargin: (pathNMo === 'contacto') ? '0px' : '-30px',
        threshold: (pathNMo === 'contacto') ? 0 : 0.3
    }

    const myObserver = new IntersectionObserver(callback, options)
    sectionReveals.forEach(section => {
        myObserver.observe(section)
    })
}


export {
    scrollingPage,
}